import React, { useState, useRef } from "react";
import SectionHeader from "../../components/ui/HeaderSection";
import { FaChevronDown } from "react-icons/fa";

const faqs = [
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
  {
    question:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry.",
    answer:
      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.",
  },
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);
  const contentRefs = useRef([]); // Simpan referensi elemen jawaban

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section
      id="faq-section"
      className="py-16 px-6 md:px-10 max-w-3xl mx-auto text-center"
    >
      {/* Header */}
      <div data-aos="fade-up" data-aos-duration="1000">
      <SectionHeader
        title="Frequently Asked Question"
        description="Lorem Ipsum is simply dummy text of the printing and typesetting industry."
        TitleColor="#EC7C65"
        DescriptionColor="#7A7A7A"
      />
</div>
      {/* FAQ List */}
      <div className="mt-20 text-left justify-start">
        {faqs.map((faq, index) => (
          <div key={index}>
            {/* FAQ Button */}
            <button
              className="w-full flex justify-between items-center py-4 text-[#2D2D2D] text-sm font-semibold text-left"
              onClick={() => toggleFAQ(index)}
            >
              <span className="flex-1 text-left pr-4">{faq.question}</span>
              <FaChevronDown
                className={`transition-transform duration-300 flex-shrink-0 ${
                  openIndex === index ? "rotate-180" : ""
                }`}
              />
            </button>

            {/* Answer Section with Smooth Expand/Collapse */}
            <div
              ref={(el) => (contentRefs.current[index] = el)}
              className="transition-all duration-500 ease-in-out overflow-hidden"
              style={{
                maxHeight:
                  openIndex === index
                    ? `${contentRefs.current[index]?.scrollHeight}px`
                    : "0px",
                opacity: openIndex === index ? 1 : 0,
              }}
            >
              <p className="text-[#7A7A7A] text-xs pb-4">{faq.answer}</p>
            </div>
            {index !== faqs.length - 1 && (
              <hr className="border-t border-gray-300" />
            )}
          </div>
        ))}
      </div>
    </section>
  );
};

export default FAQSection;
